import React from 'react';
import moment from 'moment';
import AllocationChartAndLegend from '../AllocationChartAndLegend/AllocationChartAndLegend';
import styles from './style.css';
import { formatDate } from '../../flows/shared/dateUtils';

export const PortfolioAllocationHeader = ({
  fund,
  displayHeader,
  shoppingCartEmpty,
  RDFData,
  fundAllocationsPresent = true
}) => {
  const asOfDate = RDFData
    ? formatDate(fund?.price?.asOfDate, 'MM/DD/YYYY')
    : moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('MM/DD/YYYY');

  const fundCompositionHeaderText = RDFData
    ? 'Fund Composition'
    : 'My Portfolio Allocation';

  return (
    <>
      {fundAllocationsPresent && (
        <div>
          {displayHeader && !shoppingCartEmpty && (
            <div className="portfolio-header-container">
              <div className="header">
                <span className="portfolio-headline">
                  {fundCompositionHeaderText}{' '}
                  <span className="asof-date-in-header">
                    (as of {asOfDate})
                  </span>
                </span>
              </div>
            </div>
          )}
          <style jsx>{styles}</style>
        </div>
      )}
    </>
  );
};

const PortfolioAllocation = ({
  fund,
  stocks,
  bonds,
  shortTerm,
  shoppingCartEmpty,
  displayHeader,
  small,
  openQuickViewFund,
  setOpenQuickViewFund,
  RDFData,
  isMoneyMarketView,
  fundAllocationsPresent = true
}) => {
  return (
    <div className="portfolio-allocation">
      <PortfolioAllocationHeader
        fund={fund}
        displayHeader={displayHeader}
        shoppingCartEmpty={shoppingCartEmpty}
        RDFData={RDFData}
        fundAllocationsPresent={fundAllocationsPresent}
      />

      <div className="cart-text-container">
        {shoppingCartEmpty || (
          <AllocationChartAndLegend
            fund={fund}
            stocks={stocks}
            bonds={bonds}
            shortTerm={shortTerm}
            small={small}
            openQuickViewFund={openQuickViewFund}
            setOpenQuickViewFund={setOpenQuickViewFund}
            RDFData={RDFData}
            isMoneyMarketView={isMoneyMarketView}
            fundAllocationsPresent={fundAllocationsPresent}
          />
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

PortfolioAllocation.defaultProps = {
  readOnly: false,
  shoppingCartEmpty: true,
  displayHeader: true
};

export default PortfolioAllocation;
